@import '../styles/_vars.css';

.sectionSymptoms {
  padding-top: 3.4em;
  padding-bottom: 3.4em;
}

.sectionSymptoms h2 {
  text-align: left;
  margin-bottom: 1.5em;
}

@media screen and (min-width: 481px) {
  .sectionSymptoms ul {
    column-count: 2;
  }
}

@media screen and (min-width: 1025px) {
  .sectionSymptoms ul {
    column-count: 3;
  }
}
